import React, {Component} from "react";
import {Link} from "react-router-dom";
import {BASE_LINK, ROOM_SEARCH_LINK} from "../actions/types";
import SearchIcon from "@material-ui/icons/Search";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import {client, title} from "../constName.json";
import logo_1 from './../images/logo_1.png'

class Header extends Component {
  state = {
    open: false
  };
  handleClickOpen = () => {
    document.body.style.position = "fixed";
    this.setState({open: true});
  };
  handleClose = () => {
    document.body.style.position = "";
    this.setState({open: false});
  };

  render() {
    // if (!this.props.scroll) {
    return (
        <div style={{height: "76px", position: "relative", overflow: "hidden"}}>
          <div className="navbar-header">
            {false && (<div className="header-circle" style={{right: 64, top: 37}}/>)}
            {false && (<div className="header-circle" style={{right: 24, top: 58}}/>)}
            <Link className="navbar-brand" style={{padding: 16}} to={BASE_LINK}>
              <img src={logo_1}/>
              <div>
                <div className="navbar-header-en">{client}</div>
                <div className="navbar-header-cn">{title}</div>
              </div>
            </Link>
            <div hidden={true} style={{
              position: "absolute",
              right: 48,
              bottom: 12,
              color: "#fff",
              zIndex: 10
            }} onClick={this.handleClickOpen}>
              <HelpOutlineIcon/>
            </div>
            <Link style={{
              position: "absolute",
              right: 16,
              bottom: 12,
              color: "#fff",
              zIndex: 10
            }} to={ROOM_SEARCH_LINK}>
              <SearchIcon/>
            </Link>
          </div>
          {this.renderDialog()}
        </div>
    );
    // }else{
    //   return(
    //     <div style={{height:"45px",position:"relative",overflow:"hidden"}}>
    //       <div className="navbar-header" style={{textAlign:"center"}}>
    //         <Link className="navbar-brand" to={BASE_LINK}>DCampus</Link>
    //       </div>
    //     </div>
    //   )
    // }
  }

  renderDialog() {
    return (
        <Dialog
            open={this.state.open}
            onClose={this.handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">预约需知</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <span style={{display: "block"}}>1.这是一个预约细则</span>
              <span style={{display: "block"}}>2.这是一个预约细则测试测试</span>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary" autoFocus>
              已知晓
            </Button>
          </DialogActions>
        </Dialog>
    );
  }
}

export default Header;
